
// http://39.104.163.194:8385/WHHG/  万辉  wh  123456
// http://39.104.102.42:8382/JSXDZ/ xdz  123456
// http://39.104.28.125:8084/JSLLGFZ/  兰陵  lanling   123456
import $ajax from 'axios'
import qs from 'qs';
import D3Config from '@/utils/D3Config'
const base_url=D3Config.base_url
let token= localStorage.getItem("token");
// const base_url = '/api/WHHG'
// 获取电子围栏规则
export function getElectronWarn(username,password) {
    return $ajax({
        url: base_url+'/open/information/getElectronWarn.do?',
        method: "GET",
        params:{
            username:username,
            password:password
        }
    })
}
// 获取电子围栏列表
export function getElectronWarnList(username,password) {
    return $ajax({
        url: base_url+'/open/information/getElectronWarn.do?',
        method: "GET",
        params:{
            username:username,
            password:password
        }
    })
}
// 获取电子围栏点位
export function getElectronPoint(username,password) {
    return $ajax({
        url: base_url+'/open/information/getElectronPoint.do?',
        method: "GET",
        params:{
            username:username,
            password:password
        }
    })
}
// 新增点位
export function savaElectron(params) {
    return $ajax({
        url: base_url+'/open/information/savaElectron.do',
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data:qs.stringify({data:JSON.stringify(params)})
    })
}
//修改名称
export function updateElectronNo(params) {
    return $ajax({
        url: base_url+'/updateElectronNo',
        method: "GET",
        params:params
    })
}
//删除
export function deleteElectron(id) {
    return $ajax({
        url: base_url+'/deleteElectron',
        method: "GET",
        params:{
            electron:id
        }
    })
}
//设置规则
export function updateElectronWarn(form) {
    return $ajax({
        url: base_url+'/updateElectronWarn',
        method: "GET",
        params:form
    })
}
